import gql from 'graphql-tag';

export const GET_PLAYER_LINK = gql`
  query getPlayerLink($zoneId: ID!) {
    playerLink(zoneId: $zoneId)
  }
`;
